import angular from 'angular';

let LogListController = function (Faq, $mdDialog, $filter, $scope, $state, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  angular.extend($ctrl, {
    goBack,
    showDetail,
    formatDate
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';
    $ctrl.category = {
      name: ''
    }

    $ctrl.versionList = [];

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'updated_at'
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function goBack() {
    window.history.back();
  }

  function showDetail(resource) {
    $state.go('faq.log-detail', { id: resource.id });
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Faq
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        setPlaceHolderValues(response.data);
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.email === null || item.email === undefined) {
  			item.email = $filter('translate')('common-not-informed');
  		}
  	});
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat(navigator.language).format(new Date(date))
  }
}

LogListController.$inject = ['Faq', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];

export default LogListController;



// WEBPACK FOOTER //
// ./client/app/components/faq/log-list.controller.js